import { isValidPhoneNumber, parsePhoneNumberFromString } from "libphonenumber-js";

// Resolve a string to phone number if possible
export const resolveToPhoneNumber = (inputString: string): string | undefined => {
    if (!inputString) {
        return;
    }

    return isValidPhoneNumber(inputString, "NL")
        ? parsePhoneNumberFromString(inputString, "NL")?.formatInternational()
        : undefined;
};
